import Card from "components/card";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Badge from "components/badge";
import { MdAddBox } from "react-icons/md";
import ApiList from "services/apiList";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import Loader from "components/loader";

const types = ["", "2-3 нас", "3-4 нас"];

const columns = [
  {
    label: "№",
    with: "80px",
    align: "center",
  },
  {
    label: "Нэр",
    with: "160px",
    align: "left",
  },
  {
    label: "Төрөл",
    with: "140px",
    align: "left",
  },
  {
    label: "Ангиуд",
    with: "auto",
    align: "left",
  },
];

const AngiBagtslah = () => {
  const user = useSelector(currentUser);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(ApiList.getCourseBagts);
        setData(response.result);
      } catch (error) {
        alert("Сервертэй холбогдож чадсангүй");
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Card extra="w-full h-full p-4 mt-4">
      <div className="relative mb-4 flex items-center justify-between">
        <Link
          to="/admin/angi-bagstlagh/new"
          className={`flex items-center text-md hover:cursor-pointer ${"bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"} linear justify-center rounded-lg font-bold transition duration-200`}
        >
          <MdAddBox className="h-6 w-6" /> Нэмэх
        </Link>
      </div>
      <div className="h-full overflow-x-scroll xl:overflow-hidden">
        <table className="responsive_table">
          <thead>
            <tr key={"l-header"}>
              {columns.map((column, index) => {
                if (user.school.type === 0 && column.label !== "Төрөл") {
                  return (
                    <th
                      key={"user-header" + index}
                      style={{ textAlign: column.align, width: column.with }}
                    >
                      {column.label}
                    </th>
                  );
                } else if (user.school.type === 1) {
                  return (
                    <th
                      key={"user-header" + index}
                      style={{ textAlign: column.align, width: column.with }}
                    >
                      {column.label}
                    </th>
                  );
                }
                return null;
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => {
              return (
                <tr key={i}>
                  <td style={{ textAlign: "center" }}>{i + 1}</td>
                  <td style={{ textAlign: "left" }}>
                    <Link
                      to={`/admin/angi-bagstlagh/${row.id}`}
                      className="text-left text-blue-800 underline hover:text-blue-600 dark:text-white"
                    >
                      {row.name}
                    </Link>
                  </td>
                  {user.school.type === 1 && (
                    <td style={{ textAlign: "left" }}>{types[row.type]}</td>
                  )}
                  <td style={{ textAlign: "left" }}>
                    {row.courses.map((c, index) => {
                      return (
                        <Badge
                          key={index}
                          index={index}
                          text={c.number + c.group}
                          isDisabled
                        />
                      );
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default AngiBagtslah;
